var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Access denied. You do not have sufficient permissions to view this page.")])
}
var staticRenderFns = []

export { render, staticRenderFns }